module.exports = [
  {
    key: "en",
    displayName: "English",
    default: true,
  },
  {
    key: "es",
    displayName: "Español",
  },
  {
    key: "fr",
    displayName: "Français",
  },
  {
    key: "pt",
    displayName: "Português (Brasil)",
  },
]
